

import React from 'react'

export const IletişimPage = () => {
  return (
    <div>IletişimPage</div>
  )
}
